import propTypes from 'prop-types';
import './formheader.css';
import moment from 'moment';
import OhLogo from '../../static/oh-logo-2.svg';

const isOccOrder = metadata => !!(metadata?.occ_id);

const FormHeader = (props) => {
  const { metadata } = props;
  const isOcc = isOccOrder(metadata);
  const occName = metadata?.occ_name || metadata?.hub_name;

  return (
    <div className="form-header-wrapper">
      <div className="form-header">
        <div className="header-row mb-24">
          <img src={OhLogo} alt="oh_logo" width={150} height={18} />
          <div className="request_info">Request ID: {metadata?.request_id}</div>
        </div>
        <div className="header-row">
          <span className="static-text">eMedic</span>
          <div className="static-text">Collected on</div>
        </div>
        <div className="header-row">
          <span className="emedic_info">{metadata?.emedic_name}</span>
          <div className="collection_info">
            {moment(metadata?.scheduled_at).format('Do MMM YYYY | hh:mm A')}
          </div>
        </div>
        {isOcc && occName && (
          <>
            <div className="header-row mt-12">
              <span className="static-text">Collected at</span>
            </div>
            <div className="header-row">
              <span className="occ_info">{occName}</span>
            </div>
          </>
        )}
      </div>
      <div className="meta-header">
        <div className="meta-header-text">
          Rate your sample collection experience.
        </div>
      </div>
    </div>
  );
};

FormHeader.propTypes = {
  metadata: propTypes.object,
};

export default FormHeader;
